import {
    FiHome,
    FiUsers,
    FiLock,
    FiBriefcase,
    FiTag,
    FiMapPin,
    FiX,
    FiChevronDown,
    FiList,
    FiLoader,
    FiInfo,
    FiPackage,
    FiSettings,
    FiMenu,
    FiUser,
    FiPower,
} from 'react-icons/fi';

const ICON_MAP = {
    'icon-home': FiHome,
    'icon-users': FiUsers,
    'icon-lock': FiLock,
    'icon-briefcase': FiBriefcase,
    'icon-tag': FiTag,
    'icon-map-pin': FiMapPin,
    'icon-list': FiList,
    'icon-box': FiPackage,
    'icon-settings': FiSettings,
    'icon-x': FiX,
    'icon-chevron-down': FiChevronDown,
    'icon-loader': FiLoader,
    'icon-info': FiInfo,
    'icon-menu': FiMenu,
    'icon-user': FiUser,
    'icon-power': FiPower,
};

export default function NavIcon({ name, className = '', spin = false }) {
    const Icon = ICON_MAP[name];
    if (!Icon) return null;

    return (
        <Icon
            className={[className, spin ? 'mpa-nav-icon--spin' : ''].filter(Boolean).join(' ')}
            aria-hidden="true"
        />
    );
}
